<template>
  <div class="recommended-articles-wrapper" v-if="articles.length">
    <div class="recommended-articles-title">
      Rekommenderad Läsning
    </div>
    <div
        ref="el"
        :style="{
        cursor: isDragging ? 'grabbing' : 'grab',
        scrollSnapType: isDragging ? '' : '',
        }"
        @mousedown="onMouseDown"
        @mouseup="onMouseUp"
        class="recommended-articles"
    >
      <a
          v-for="(article, index) in articles"
          v-bind:key="index"
          :class="index == articles.length - 1 ? 'mr-0 card-wrapper d-flex' : 'card-wrapper d-flex'">
        <div class="flex flex-column flex-wrap">
          <div
              class="card-title-wrapper"
              :style="{
              background: 'linear-gradient(180deg, rgba(22,22,22,0) 0%, rgba(22,22,22,0) 7%, rgba(22,22,22,0.15) 15%, rgba(23,23,23,0.48) 37%, rgba(23,23,23,0.77) 69%, rgba(24,24,24,0.9) 100%), url(' + article.image + ')' }">
            <div v-if="article.sponsored" class="recommended-sponsored-badge">
              <span>Sponsrat innehåll</span>
            </div>
            <div class="small-title d-flex mb-2">
              <span v-if="article.author">
                <span>{{ article.author.name }}</span>|<span>{{ article.read_time }}</span>
              </span>
            </div>
            <h5 class="big-title mb-0">
              <a :href="`${article.slug}`" class="text-white">
                <span
                    v-if="article.title">{{
                    article.title.length > 70 ? article.title.substring(0, 70) + '...' : article.title
                  }}</span>
                <span v-else>-</span>
              </a>
            </h5>
          </div>
        </div>
      </a>
    </div>
    <div class="recommended-articles-buttons">
      <div @click="handleScroll('left')" class="prev-articles scroll-button">
        <i class="fal fa-angle-left"></i>
      </div>
      <div @click="handleScroll('right')" class="next-articles scroll-button">
        <i class="fal fa-angle-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['article_id'],
  data() {
    return {
      articles: [],
      isDragging: false,
      cursorPos: [0, 0],
      el: null,
    };
  },
  mounted() {
    this.getRecommendedArticles();
  },
  methods: {
    async getRecommendedArticles() {
      try {
        const response = await fetch(`/api/articles/${this.article_id}/recommended`);
        this.articles = await response.json();
      } catch (error) {
        console.error('Error fetching recommended articles:', error);
      }
    },
    onMouseDown(ev) {
      this.cursorPos = [ev.pageX, ev.pageY];
      this.isDragging = true;
      window.addEventListener('mousemove', this.onMouseHold);
    },
    onMouseUp() {
      this.isDragging = false;
      window.removeEventListener('mousemove', this.onMouseHold);
    },
    onMouseHold(ev) {
      ev.preventDefault();
      const rect = this.$refs.el.getBoundingClientRect();
      if (ev.pageX < rect.left || ev.pageX > rect.right) {
        window.removeEventListener('mousemove', this.onMouseHold);
      }

      requestAnimationFrame(() => {
        const delta = [
          ev.pageX - this.cursorPos[0],
          ev.pageY - this.cursorPos[1],
        ];

        this.cursorPos = [ev.pageX, ev.pageY];
        if (!this.$refs.el) return;

        this.$refs.el.scrollBy({
          left: -delta[0],
          top: -delta[1],
        });
      });
    },
    handleScroll(direction) {
      if (this.$refs.el) {
        this.$refs.el.scrollBy({
          left: direction === 'left' ? -300 : 300,
          behavior: 'smooth',
        });
      }
    },
  },
};
</script>

<style scoped>
.recommended-articles-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;

}

.recommended-articles {
  display: flex;
  width: 100%;
  overflow: auto;
}

.card-wrapper {
  max-width: 253px;
  max-height: 185px;
  margin-right: 1rem;
  flex: none;
  text-decoration: none !important;
  transition: none !important;
  scroll-snap-align: start;
}

.card-title-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 185px;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  color: white !important;
  width: 100%;
  padding: 1.25rem;
  position: relative;
}

.small-title {
  font-size: .75rem;
  color: #FFFFFF;
  font-weight: 600;
}

.big-title {
  font-size: 1.125rem;
  color: #FFFFFF;
  font-weight: 600;
  word-break: break-word;
}

.card-short_description {
  height: 70px;
  background-color: white;
  font-size: .8rem;
  padding: 1rem 1.25rem;
  font-weight: 400;
  word-break: break-word;
}

.recommended-articles-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.25rem;
}

.scroll-button {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1rem;
  cursor: pointer;
  border: 1px solid rgba(159,159,159,.3);
}

.scroll-button i {
  font-size: 1.25rem;
  color: #2189ca;
}

.recommended-sponsored-badge {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #2189caa6;
  padding: 0.25rem 0.5rem;
  text-align: center;
  font-size: .75rem;
  font-weight: 600;
  color: white;
  width: 100%;
}

@media (max-width: 767.98px) {
  .recommended-articles-wrapper {
    margin-bottom: 0;
  }

  .recommended-articles {
    flex-direction: column;
    height: auto;
  }

  .card-wrapper {
    max-width: 100%;
    flex: 1;
    flex-flow: column;
    margin-bottom: 1.25rem;
    margin-right: 0;
  }

  .recommended-articles-buttons {
    display: none;
  }
}
</style>
